import React from "react"
import tw, { styled } from "twin.macro"

export enum Containers {
  Desktop = "desktop",
  DesktopLG = "desktop-lg",
  Widescreen = "widescreen",
  Full = "full",
}

export const Container = styled("div")`
  ${tw`max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative z-10 h-full tablet:h-auto`};
`

export interface GridProps {
  divide?: boolean
}

export const Grid = styled("div")(({ divide }: GridProps) => [
  tw`grid grid-cols-4 tablet:grid-cols-12 gap-4 desktop:gap-6 gap-y-0 h-full tablet:h-auto`,
  divide == true && tw`tablet:divide-x-2 tablet:divide-base-2`,
])

type GridContainerProps = {
  children: React.ReactNode
  container?: string
  divide?: boolean
}

export default function GridContainer(props: GridContainerProps) {
  switch (props.container) {
    case Containers.Desktop:
      return (
        <Container tw="max-w-screen-desktop desktop:mx-auto">
          <Grid {...props}>{props.children}</Grid>
        </Container>
      )
    case Containers.Widescreen:
      return (
        <Container tw="max-w-screen-widescreen desktop:mx-auto">
          <Grid {...props}>{props.children}</Grid>
        </Container>
      )
    case Containers.Full:
      return (
        <Container tw="max-w-none px-0 desktop:mx-auto">
          <Grid {...props}>{props.children}</Grid>
        </Container>
      )
    default:
      return (
        <Container>
          <Grid {...props}>{props.children}</Grid>
        </Container>
      )
  }
}
